import { useMemo } from 'react';

const useCompanyUrl = () => {
    const generateCompanyUrl = (slug) => {
        return `/employer/${slug}`;
    };
    return useMemo(() => generateCompanyUrl, []);
};

export default useCompanyUrl